import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';

import { Store } from '@ngrx/store';

import { Subject, timer } from 'rxjs';
import { filter, switchMap, takeUntil, withLatestFrom } from 'rxjs/operators';

import { select } from '@ngrx/store';
import { AppState } from './model/reducer';
import { InitApplication } from './model/actions';
import { isAuthenticatedView } from './model/views';
import { CustomSvgIconService } from './common/services/custom-svg-icon.service';
import { ApplicationTitleService } from './common/services/application-title/application-title.service';
import { UserService } from './user/login/user.service';
import { StartupChecksService } from './common/services/startup-checks.service';

@Component({
    selector: 'adm4-root',
    template: '<adm4-root-layout></adm4-root-layout>',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  private store$ = inject<Store<AppState>>(Store);
  private customSvgIconService = inject(CustomSvgIconService);
  private appTitleService = inject(ApplicationTitleService);
  private userService = inject(UserService);
  private _startupChecks = inject(StartupChecksService);

  private POLLING_INTERVAL = 60000;
  private destroyed$: Subject<boolean> = new Subject();

  ngOnInit(): void {
    this.customSvgIconService.registerIcons();
    this.store$.dispatch(new InitApplication());
    this.appTitleService.startService(this.router);
    this.globalPolling();
  }

  private globalPolling(): void {
    timer(1, this.POLLING_INTERVAL).pipe(
      takeUntil(this.destroyed$),
      withLatestFrom(this.store$.pipe(select(isAuthenticatedView))),
      filter(([, isAuthenticated]) => isAuthenticated),
      switchMap(() => this.userService.getUserData()))
      .subscribe();
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
